/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/offcanvas';
import './components/delay-search-queries';
import './components/video';
import './components/footer-menus';
import './components/scroll-to-top';
import './components/foundation.app';
import './components/accessibility';
import './components/lazy.jquery';
import './components/copy-link';
import './components/wp-gallery-swiper';
import './components/vacancies';
import './components/sticky-header-scroll';

function updateMexicanFlags() {
  const menus = document.querySelectorAll('.translation-menu');

  menus.forEach(menu => {
    const spans = menu.querySelectorAll('span');

    spans.forEach(span => {
      if (span.textContent.trim().toLowerCase() === 'mx') {
        const wrapper = span.closest('.lang-wrapper');
        const img = wrapper?.querySelector('img.langflag');

        if (img && !img.src.endsWith('/mx.svg')) {
          img.src = img.src.replace(/\/[a-z]{2}\.svg$/i, '/mx.svg');
        }
      }
    });
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', updateMexicanFlags);
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateMexicanFlags, 200);
});
